import React, { useEffect, useState } from 'react';
import { Navigate } from 'react-router-dom';
import { api } from '@/controllers/api';

interface PrivateRouteProps {
    children: React.ReactNode;
    // Si spécifié, seuls les utilisateurs avec ce rôle accèdent à la route.
    // Les autres utilisateurs authentifiés sont redirigés vers /admin/statistiques.
    requiredRole?: string;
}

export const PrivateRoute = ({ children, requiredRole }: PrivateRouteProps) => {
    const [status, setStatus] = useState<'loading' | 'ok' | 'unauthorized' | 'forbidden'>('loading');

    useEffect(() => {
        api.auth.me()
            .then(({ user }) => {
                if (requiredRole && user?.role !== requiredRole) {
                    setStatus('forbidden');
                } else {
                    setStatus('ok');
                }
            })
            .catch(() => setStatus('unauthorized'));
    }, [requiredRole]);

    if (status === 'loading') {
        return (
            <div className="min-h-screen bg-[#0d1117] flex flex-col items-center justify-center text-primary">
                <span className="material-symbols-outlined text-4xl animate-spin mb-4">progress_activity</span>
                <p>Authentification...</p>
            </div>
        );
    }

    if (status === 'unauthorized') return <Navigate to="/admin/login" />;
    if (status === 'forbidden') return <Navigate to="/admin/statistiques" replace />;
    return <>{children}</>;
};
